export function tooltipInit(){
var logoImages = document.querySelectorAll(".logo-image");
logoImages.forEach(function(logoImage, index){  
    // For each logo_image
    logoImage.addEventListener("mouseover", position_tooltip); // On hover, launch the function below
    logoImage.addEventListener("click", position_tooltip); // On click, launch the function below (for mobiles)
})

const openTooltipButtons = document.querySelectorAll('[data-modal-target]');  
const closeTooltipButtons = document.querySelectorAll('[data-close-button]');


openTooltipButtons.forEach(button => {
  button.addEventListener('mouseover', () => {
    const modals = document.querySelectorAll('.logo-text.active');
    modals.forEach(modal => {
    closeTooltip(modal);
  })
    const modal = document.querySelector(button.dataset.modalTarget);
    openTooltip(modal);
  })
})

closeTooltipButtons.forEach(button => {
  button.addEventListener('click', () => {
    const modal = button.closest('.logo-text');
    closeTooltip(modal);
  })
})

function openTooltip(modal) {
  if (modal == null) return
  modal.classList.add('active');
}

function closeTooltip(modal) {
  if (modal == null) return
  modal.classList.remove('active');
}

function position_tooltip(){    
  // Get .logo_imagetext sibling
  var tooltip = this.parentNode.querySelector(".logo-text");
  // Get calculated tooltip coordinates and size
  var tooltip_rect = tooltip.getBoundingClientRect();
  var image_rect = this.getBoundingClientRect();

  let rectWidth = 400;
  if (window.innerWidth < 768) {
    rectWidth = 300;
  }
  console.log(tooltip_rect.width);
  // Corrections if out of window
  if ((image_rect.x + rectWidth) > window.innerWidth) // Out on the right
  tooltip.classList.add("reverse");  // Add class to apply transition
  else
  tooltip.classList.remove("reverse"); // Remove class to apply transition
}
}
